import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { CookieConsent } from "./components/CookieConsent";
import { Layout } from "./components/Layout";
import { CommunityPage } from "./pages/CommunityPage";
import { CookiesPage } from "./pages/legal/CookiesPage";
import { LegalNoticePage } from "./pages/legal/LegalNoticePage";
import { PrivacyPage } from "./pages/legal/PrivacyPage";
import { RefundPage } from "./pages/legal/RefundPage";
import { TermsPage } from "./pages/legal/TermsPage";
import { CreatePage } from "./pages/CreatePage";
import { DashboardPage } from "./pages/DashboardPage";
import { FilamentsPage } from "./pages/FilamentsPage";
import { GeneratorsPage } from "./pages/GeneratorsPage";
import { IntegrationsPage } from "./pages/IntegrationsPage";
import { JobDetailPage } from "./pages/JobDetailPage";
import { JobsPage } from "./pages/JobsPage";
import { LandingPage } from "./pages/LandingPage";
import { PrintersPage } from "./pages/PrintersPage";
import { ProfilePage } from "./pages/ProfilePage";
import { SettingsPage } from "./pages/SettingsPage";
import { ProjectDetailPage } from "./pages/ProjectDetailPage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { SharedPage } from "./pages/SharedPage";

// The Studio pulls in Three.js -- code-split it so it only loads when opened.
const StudioPage = lazy(() => import("./pages/StudioPage").then((m) => ({ default: m.StudioPage })));

function Loading() {
  return <div className="row" style={{ justifyContent: "center", padding: 60, color: "var(--muted)" }}><span className="spinner" /></div>;
}

export default function App() {
  return (
    <>
    <Routes>
      {/* Public marketing vitrine -- full-bleed, no app chrome. */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/tendances" element={<LandingPage initialView="tendances" />} />
      <Route path="/recents" element={<LandingPage initialView="recents" />} />
      <Route path="/categories" element={<LandingPage initialView="categories" />} />
      <Route path="/tarifs" element={<LandingPage initialView="tarifs" />} />
      {/* Public legal pages (SoClose Singapore branding kit). */}
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/cookies" element={<CookiesPage />} />
      <Route path="/refund" element={<RefundPage />} />
      <Route path="/legal" element={<LegalNoticePage />} />
      <Route element={<Layout />}>
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="create" element={<CreatePage />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/:id" element={<ProjectDetailPage />} />
        <Route path="studio" element={<Suspense fallback={<Loading />}><StudioPage /></Suspense>} />
        <Route path="production" element={<JobsPage />} />
        <Route path="production/:jobId" element={<JobDetailPage />} />
        <Route path="generators" element={<GeneratorsPage />} />
        <Route path="integrations" element={<IntegrationsPage />} />
        <Route path="printers" element={<PrintersPage />} />
        <Route path="filaments" element={<FilamentsPage />} />
        <Route path="community" element={<CommunityPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="shared/:token" element={<SharedPage />} />
        <Route path="*" element={<DashboardPage />} />
      </Route>
    </Routes>
    <CookieConsent />
    </>
  );
}
